import {
  actions,
  contactUsDataasDataTableAsync,
  contactUsAsync,
  contactUsPublicAsync,
} from './slices';

export const ContactUsActions = {
  ...actions,
  contactUsDataasDataTableAsync,
  contactUsAsync,
  contactUsPublicAsync,
};
